import React, { useState } from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { ChevronLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const PostJob = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    companyWebsite: '',
    companyLogo: '',
    jobTitle: '',
    jobDescription: '',
    jobType: 'full-time',
    workLocation: 'remote',
    minSalary: '',
    maxSalary: '',
    currency: 'USD',
    applicationUrl: '',
    applicationEmail: '',
    skills: [],
    newSkill: ''
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    // Clear error when field is updated
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };
  const addSkill = () => {
    if (formData.newSkill.trim() && !formData.skills.includes(formData.newSkill.trim())) {
      setFormData({
        ...formData,
        skills: [...formData.skills, formData.newSkill.trim()],
        newSkill: ''
      });
    }
  };
  const removeSkill = (skillToRemove: string) => {
    setFormData({
      ...formData,
      skills: formData.skills.filter(skill => skill !== skillToRemove)
    });
  };
  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.companyName.trim()) {
      newErrors.companyName = 'Company name is required';
    }
    if (!formData.jobTitle.trim()) {
      newErrors.jobTitle = 'Job title is required';
    }
    if (!formData.jobDescription.trim()) {
      newErrors.jobDescription = 'Job description is required';
    }
    if (formData.skills.length === 0) {
      newErrors.skills = 'At least one skill is required';
    }
    if (!formData.applicationUrl.trim() && !formData.applicationEmail.trim()) {
      newErrors.applicationUrl = 'Either application URL or email is required';
      newErrors.applicationEmail = 'Either application URL or email is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitting(true);
      // Simulate API call
      setTimeout(() => {
        setIsSubmitting(false);
        setIsSuccess(true);
        // Reset form after success
        setFormData({
          companyName: '',
          companyWebsite: '',
          companyLogo: '',
          jobTitle: '',
          jobDescription: '',
          jobType: 'full-time',
          workLocation: 'remote',
          minSalary: '',
          maxSalary: '',
          currency: 'USD',
          applicationUrl: '',
          applicationEmail: '',
          skills: [],
          newSkill: ''
        });
      }, 1500);
    }
  };
  if (isSuccess) {
    return <div className="w-full py-20 bg-[#F8FAFC]" data-id="element-1066">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-1067">
          <Card className="text-center py-12 border-gray-200 rounded-2xl shadow-sm" data-id="element-1068">
            <div className="flex flex-col items-center" data-id="element-1069">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-1070">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1071">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1072"></path>
                </svg>
              </div>
              <h2 className="font-display text-2xl font-bold text-gray-900 mb-3" data-id="element-1073">
                Job Posted Successfully!
              </h2>
              <p className="text-gray-600 mb-8 max-w-md" data-id="element-1074">
                Your job listing has been submitted and is pending review.
                You'll receive a confirmation email once it's published.
              </p>
              <div className="flex gap-4" data-id="element-1075">
                <Link to="/" data-id="element-1076">
                  <button className="px-6 py-3 text-gray-700 bg-white border border-gray-300 rounded-full font-medium hover:bg-gray-50 transition-colors duration-200" data-id="element-1077">
                    Return Home
                  </button>
                </Link>
                <button onClick={() => setIsSuccess(false)} className="px-6 py-3 text-white bg-[#d73b3e] rounded-full font-medium hover:bg-[#c02f32] transition-colors duration-200" data-id="element-1078">
                  Post Another Job
                </button>
              </div>
            </div>
          </Card>
        </div>
      </div>;
  }
  return <div className="w-full py-20 bg-[#F8FAFC]" data-id="element-1079">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-1080">
        <div className="mb-8" data-id="element-1081">
          <Link to="/" className="inline-flex items-center text-gray-600 hover:text-[#d73b3e] transition-colors" data-id="element-1082">
            <ChevronLeftIcon className="w-5 h-5 mr-1" data-id="element-1083" />
            Back to Home
          </Link>
        </div>
        <div className="text-center mb-12" data-id="element-1084">
          <h1 className="font-display text-3xl font-bold text-gray-900 mb-3" data-id="element-1085">
            Post a Job
          </h1>
          <p className="text-gray-600 max-w-xl mx-auto" data-id="element-1086">
            Reach thousands of certified Laravel developers by posting your job
            opening on our platform.
          </p>
        </div>
        <Card className="rounded-xl shadow-sm" data-id="element-1087">
          <form onSubmit={handleSubmit} className="space-y-8" data-id="element-1088">
            {/* Company Information */}
            <div data-id="element-1089">
              <h2 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-1090">
                Company Information
              </h2>
              <div className="space-y-4" data-id="element-1091">
                <div data-id="element-1092">
                  <label htmlFor="companyName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1093">
                    Company Name <span className="text-[#FF3B30]" data-id="element-1094">*</span>
                  </label>
                  <input type="text" id="companyName" name="companyName" value={formData.companyName} onChange={handleChange} className={`w-full px-4 py-3 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF3B30] transition-all ${errors.companyName ? 'bg-red-50 border-2 border-[#FF3B30]' : 'bg-gray-50'}`} data-id="element-1095" />
                  {errors.companyName && <p className="mt-2 text-sm text-[#FF3B30]" data-id="element-1096">
                      {errors.companyName}
                    </p>}
                </div>
                <div data-id="element-1097">
                  <label htmlFor="companyWebsite" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1098">
                    Company Website
                  </label>
                  <input type="url" id="companyWebsite" name="companyWebsite" value={formData.companyWebsite} onChange={handleChange} placeholder="https://" className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-transparent transition-all" data-id="element-1099" />
                </div>
                <div data-id="element-1100">
                  <label htmlFor="companyLogo" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1101">
                    Company Logo URL
                  </label>
                  <input type="url" id="companyLogo" name="companyLogo" value={formData.companyLogo} onChange={handleChange} placeholder="https://" className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-transparent transition-all" data-id="element-1102" />
                  <p className="mt-2 text-xs text-gray-500" data-id="element-1103">
                    Provide a URL to your company logo (recommended size:
                    200x200px)
                  </p>
                </div>
              </div>
            </div>
            {/* Job Details */}
            <div className="pt-6 border-t border-gray-200" data-id="element-1104">
              <h2 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-1105">
                Job Details
              </h2>
              <div className="space-y-4" data-id="element-1106">
                <div data-id="element-1107">
                  <label htmlFor="jobTitle" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1108">
                    Job Title <span className="text-[#FF3B30]" data-id="element-1109">*</span>
                  </label>
                  <input type="text" id="jobTitle" name="jobTitle" value={formData.jobTitle} onChange={handleChange} className={`w-full px-4 py-3 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF3B30] transition-all ${errors.jobTitle ? 'bg-red-50 border-2 border-[#FF3B30]' : 'bg-gray-50'}`} placeholder="e.g., Senior Laravel Developer" data-id="element-1110" />
                  {errors.jobTitle && <p className="mt-2 text-sm text-[#FF3B30]" data-id="element-1111">
                      {errors.jobTitle}
                    </p>}
                </div>
                <div data-id="element-1112">
                  <label htmlFor="jobDescription" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1113">
                    Job Description <span className="text-[#FF3B30]" data-id="element-1114">*</span>
                  </label>
                  <textarea id="jobDescription" name="jobDescription" value={formData.jobDescription} onChange={handleChange} rows={6} className={`w-full px-4 py-3 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF3B30] transition-all resize-vertical ${errors.jobDescription ? 'bg-red-50 border-2 border-[#FF3B30]' : 'bg-gray-50'}`} data-id="element-1115" />
                  {errors.jobDescription && <p className="mt-2 text-sm text-[#FF3B30]" data-id="element-1116">
                      {errors.jobDescription}
                    </p>}
                  <p className="mt-2 text-xs text-gray-500" data-id="element-1117">
                    Provide a detailed description of the role,
                    responsibilities, and requirements.
                  </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1118">
                  <div data-id="element-1119">
                    <label htmlFor="jobType" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1120">
                      Job Type
                    </label>
                    <select id="jobType" name="jobType" value={formData.jobType} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-transparent transition-all" data-id="element-1121">
                      <option value="full-time" data-id="element-1122">Full-time</option>
                      <option value="part-time" data-id="element-1123">Part-time</option>
                      <option value="contract" data-id="element-1124">Contract</option>
                      <option value="freelance" data-id="element-1125">Freelance</option>
                      <option value="internship" data-id="element-1126">Internship</option>
                    </select>
                  </div>
                  <div data-id="element-1127">
                    <label htmlFor="workLocation" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1128">
                      Work Location
                    </label>
                    <select id="workLocation" name="workLocation" value={formData.workLocation} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-transparent transition-all" data-id="element-1129">
                      <option value="remote" data-id="element-1130">Remote</option>
                      <option value="on-site" data-id="element-1131">On-site</option>
                      <option value="hybrid" data-id="element-1132">Hybrid</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1133">
                  <div data-id="element-1134">
                    <label htmlFor="minSalary" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1135">
                      Min Salary
                    </label>
                    <input type="number" id="minSalary" name="minSalary" value={formData.minSalary} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-transparent transition-all" data-id="element-1136" />
                  </div>
                  <div data-id="element-1137">
                    <label htmlFor="maxSalary" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1138">
                      Max Salary
                    </label>
                    <input type="number" id="maxSalary" name="maxSalary" value={formData.maxSalary} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-transparent transition-all" data-id="element-1139" />
                  </div>
                  <div data-id="element-1140">
                    <label htmlFor="currency" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1141">
                      Currency
                    </label>
                    <select id="currency" name="currency" value={formData.currency} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-transparent transition-all" data-id="element-1142">
                      <option value="USD" data-id="element-1143">USD</option>
                      <option value="EUR" data-id="element-1144">EUR</option>
                      <option value="GBP" data-id="element-1145">GBP</option>
                      <option value="CAD" data-id="element-1146">CAD</option>
                      <option value="AUD" data-id="element-1147">AUD</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {/* Required Skills */}
            <div data-id="element-1148">
              <h2 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-1149">
                Required Skills
              </h2>
              <div className="space-y-4" data-id="element-1150">
                <div data-id="element-1151">
                  <label htmlFor="newSkill" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1152">
                    Add Skills <span className="text-[#FF3B30]" data-id="element-1153">*</span>
                  </label>
                  <div className="flex" data-id="element-1154">
                    <input type="text" id="newSkill" name="newSkill" value={formData.newSkill} onChange={handleChange} className={`flex-grow px-4 py-3 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-[#FF3B30] transition-all shadow-sm ${errors.skills ? 'bg-red-50 border-2 border-[#FF3B30]' : 'bg-gray-50'}`} placeholder="e.g., Laravel, PHP, Vue.js" data-id="element-1155" />
                    <button type="button" onClick={addSkill} className="bg-gray-100 px-4 py-3 rounded-r-lg hover:bg-gray-200 focus:outline-none transition-all" data-id="element-1156">
                      Add
                    </button>
                  </div>
                  {errors.skills && <p className="mt-2 text-sm text-[#FF3B30]" data-id="element-1157">
                      {errors.skills}
                    </p>}
                </div>
                {formData.skills.length > 0 && <div className="flex flex-wrap gap-2 mt-2" data-id="element-1158">
                    {formData.skills.map((skill, index) => <div key={index} className="bg-gray-100 text-gray-800 px-3 py-1.5 rounded-full flex items-center text-sm" data-id="element-1159">
                        {skill}
                        <button type="button" onClick={() => removeSkill(skill)} className="ml-2 text-gray-500 hover:text-[#FF3B30] focus:outline-none transition-all" data-id="element-1160">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1161">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-1162"></path>
                          </svg>
                        </button>
                      </div>)}
                  </div>}
              </div>
            </div>
            {/* Application Details */}
            <div data-id="element-1163">
              <h2 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-1164">
                Application Details
              </h2>
              <div className="space-y-4" data-id="element-1165">
                <div data-id="element-1166">
                  <label htmlFor="applicationUrl" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1167">
                    Application URL
                  </label>
                  <input type="url" id="applicationUrl" name="applicationUrl" value={formData.applicationUrl} onChange={handleChange} className={`w-full px-4 py-3 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF3B30] transition-all ${errors.applicationUrl ? 'bg-red-50 border-2 border-[#FF3B30]' : 'bg-gray-50'}`} placeholder="https://" data-id="element-1168" />
                  {errors.applicationUrl && <p className="mt-2 text-sm text-[#FF3B30]" data-id="element-1169">
                      {errors.applicationUrl}
                    </p>}
                </div>
                <div data-id="element-1170">
                  <label htmlFor="applicationEmail" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1171">
                    Application Email
                  </label>
                  <input type="email" id="applicationEmail" name="applicationEmail" value={formData.applicationEmail} onChange={handleChange} className={`w-full px-4 py-3 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF3B30] transition-all ${errors.applicationEmail ? 'bg-red-50 border-2 border-[#FF3B30]' : 'bg-gray-50'}`} data-id="element-1172" />
                  {errors.applicationEmail && <p className="mt-2 text-sm text-[#FF3B30]" data-id="element-1173">
                      {errors.applicationEmail}
                    </p>}
                  <p className="mt-2 text-xs text-gray-500" data-id="element-1174">
                    Provide either an application URL or email where candidates
                    can apply.
                  </p>
                </div>
              </div>
            </div>
            {/* Submit Button */}
            <div className="pt-6 border-t border-gray-200" data-id="element-1175">
              <button type="submit" disabled={isSubmitting} className="w-full px-6 py-4 bg-[#d73b3e] text-white rounded-full font-semibold text-lg hover:bg-[#c02f32] transition-all duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1176">
                {isSubmitting ? 'Submitting...' : 'Post Job'}
              </button>
              <p className="mt-4 text-sm text-center text-gray-600" data-id="element-1177">
                By posting a job, you agree to our{' '}
                <Link to="/terms-of-service" className="text-[#d73b3e] hover:underline" data-id="element-1178">
                  Terms of Service
                </Link>{' '}
                and{' '}
                <Link to="/privacy-policy" className="text-[#d73b30] hover:underline" data-id="element-1179">
                  Privacy Policy
                </Link>
                .
              </p>
            </div>
          </form>
        </Card>
        <div className="mt-12 bg-gradient-to-br from-[#FFF5F5] to-white rounded-xl p-8 shadow-sm" data-id="element-1180">
          <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1181">
            Why post on CertifiedDevs?
          </h3>
          <ul className="space-y-3" data-id="element-1182">
            <li className="flex items-start" data-id="element-1183">
              <svg className="w-5 h-5 text-[#d73b3e] mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1184">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1185"></path>
              </svg>
              <span className="text-gray-700" data-id="element-1186">
                Access to 4,500+ certified developers with verified skills
              </span>
            </li>
            <li className="flex items-start" data-id="element-1187">
              <svg className="w-5 h-5 text-[#d73b3e] mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1188">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1189"></path>
              </svg>
              <span className="text-gray-700" data-id="element-1190">
                Your job will be featured in our weekly newsletter to developers
              </span>
            </li>
            <li className="flex items-start" data-id="element-1191">
              <svg className="w-5 h-5 text-[#d73b3e] mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1192">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1193"></path>
              </svg>
              <span className="text-gray-700" data-id="element-1194">
                30-day listing with options to extend or feature your post
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>;
};
export default PostJob;